<template>
	<div>
		<b-row>
			<b-col sm="12" md="12" lg="6">
				<app-filtro-tabela v-model="filtro" v-if="mostrarFiltro"></app-filtro-tabela>
			</b-col>
			<b-col sm="12" md="12" lg="6">
				<slot name="botoes"></slot>
			</b-col>
		</b-row>
		<b-table
			striped
			hover
			bordered
			small
			:responsive="responsive"
			:id="idTabela"
			:ref="idTabela"
			:items="itens"
			:fields="campos"
			empty-text="Não existem dados a serem exibidos"
			empty-filtered-text="Não existem dados a serem exibidos"
			:show-empty="mostrarVazio"
			:per-page="itensPorPaginaSelected"
			:current-page="paginaAtual"
			:filter="filtrar"
			:busy="emProcessamento"
			@filtered="onFiltered"
		>
			<template v-for="campo in campos" :slot="campo.key" slot-scope="data">
				<div v-if="campo.key.split('.').length === 4" :key="campo.key">
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type === 'date'"
					>{{ $moment(data.item[campo.key.split('.')[0]][campo.key.split('.')[1]][campo.key.split('.')[2]][campo.key.split('.')[3]]).format("DD/MM/YYYY") }}</slot>
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type === 'datetime'"
					>{{ $moment(data.item[campo.key.split('.')[0]][campo.key.split('.')[1]][campo.key.split('.')[2]][campo.key.split('.')[3]]).format("DD/MM/YYYY HH:mm") }}</slot>
					<slot :name="campo.key" v-bind="data.item" v-if="campo.type === 'status'">
						<app-status
							:status="data.item[campo.key.split('.')[0]][campo.key.split('.')[1]][campo.key.split('.')[2]][campo.key.split('.')[3]]"
						></app-status>
					</slot>
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type !== 'date' && campo.type !== 'datetime' && campo.type !== 'status'"
					>{{ data.item[campo.key.split('.')[0]][campo.key.split('.')[1]][campo.key.split('.')[2]][campo.key.split('.')[3]] }}</slot>
				</div>
				<div v-if="campo.key.split('.').length === 3" :key="campo.key">
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type === 'date'"
					>{{ $moment(data.item[campo.key.split('.')[0]][campo.key.split('.')[1]][campo.key.split('.')[2]]).format("DD/MM/YYYY") }}</slot>
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type === 'datetime'"
					>{{ $moment(data.item[campo.key.split('.')[0]][campo.key.split('.')[1]][campo.key.split('.')[2]]).format("DD/MM/YYYY HH:mm") }}</slot>
					<slot :name="campo.key" v-bind="data.item" v-if="campo.type === 'status'">
						<app-status
							:status="data.item[campo.key.split('.')[0]][campo.key.split('.')[1]][campo.key.split('.')[2]]"
						></app-status>
					</slot>
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type !== 'date' && campo.type !== 'datetime' && campo.type !== 'status'"
					>{{ data.item[campo.key.split('.')[0]][campo.key.split('.')[1]][campo.key.split('.')[2]] }}</slot>
				</div>
				<div v-if="campo.key.split('.').length === 2" :key="campo.key">
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type === 'date'"
					>{{ $moment(data.item[campo.key.split('.')[0]][campo.key.split('.')[1]]).format("DD/MM/YYYY") }}</slot>
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type === 'datetime'"
					>{{ $moment(data.item[campo.key.split('.')[0]][campo.key.split('.')[1]]).format("DD/MM/YYYY HH:mm") }}</slot>
					<slot :name="campo.key" v-bind="data.item" v-if="campo.type === 'status'">
						<app-status :status="data.item[campo.key.split('.')[0]][campo.key.split('.')[1]]"></app-status>
					</slot>
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type !== 'date' && campo.type !== 'datetime' && campo.type !== 'status'"
					>{{ data.item[campo.key.split('.')[0]][campo.key.split('.')[1]] }}</slot>
				</div>
				<div v-if="campo.key.split('.').length === 1" :key="campo.key">
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type === 'date'"
					>{{ data.item[campo.key] ? $moment(data.item[campo.key]).format("DD/MM/YYYY") : '' }}</slot>
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type === 'datetime'"
					>{{ data.item[campo.key] ? $moment(data.item[campo.key]).format("DD/MM/YYYY HH:mm") : ''}}</slot>
					<slot :name="campo.key" v-bind="data.item" v-if="campo.type === 'status'">
						<app-status :status="data.item[campo.key]"></app-status>
					</slot>
					<slot
						:name="campo.key"
						v-bind="data.item"
						v-if="campo.type !== 'date' && campo.type !== 'datetime' && campo.type !== 'status'"
					>{{ data.item[campo.key] }}</slot>
				</div>
			</template>
		</b-table>
		<app-paginacao
			:totalItens="totalItens"
			:itensPorPagina="itensPorPaginaSelected"
			v-model="paginaAtual"
			v-if="itensPorPagina > 0"
		>
			<template slot="paginacao">
				<b-form-select v-model="itensPorPaginaSelected" :options="itensPorPaginaOptions"></b-form-select>
			</template>
		</app-paginacao>
	</div>
</template>

<script>
import PaginacaoComponent from './PaginacaoComponent'
import FiltroTabelaComponent from './FiltroTabelaComponent'
import { textoMixin } from './../bibliotecas/textoMixin'

export default {
	mixins: [textoMixin],
	name: 'app-tabela',
	props: {
		idTabela: {
			type: String,
			default: 'appTabela'
		},
		itens: {
			type: Array
		},
		campos: {
			type: Array
		},
		itensPorPagina: {
			type: Number,
			default: 5
		},
		emProcessamento: {
			type: Boolean,
			default: false
		},
		mostrarFiltro: {
			type: Boolean,
			default: true
		},
		responsive: {
			type: Boolean,
			default: true
		}

	},
	data() {
		return {
			mostrarVazio: true,
			totalItens: 0,
			paginaAtual: 1,
			filtro: '',
			itensPorPaginaSelected: this.itensPorPagina,
			itensPorPaginaOptions: [
				{ value: 5, text: 5 },
				{ value: 10, text: 10 },
				{ value: 25, text: 25 },
				{ value: 50, text: 50 },
				{ value: 100, text: 100 }
			]
		}
	},

	methods: {
		onFiltered(filteredItems) {
			this.totalItens = filteredItems.length
			this.paginaAtual = 1
		},

		filtrar(data) {
			let retorno = false
			if (this.filtro) {
				this.campos.forEach(campo => {
					if (campo.filterable) {
						let tempText
						if (campo.key.split('.').length === 1) {
							if (typeof data[campo.key] === 'string') {
								tempText = data[campo.key].textoNormalizado()
							} else {
								tempText = JSON.stringify(
									data[campo.key]
								).textoNormalizado()
							}
						} else {
							tempText = JSON.stringify(
								data[campo.key.split('.')[0]]
							).textoNormalizado()
						}
						retorno =
							retorno ||
							tempText.search(this.filtro.textoNormalizado()) !==
								-1
					}
				})
			} else {
				retorno = true
			}
			return retorno
		},

		deepFind(obj, path) {
			let paths = path.split('.')
			let current = obj

			for (let i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined
				} else {
					current = current[paths[i]]
				}
			}
			return current
		}
	},

	watch: {
		itens() {
			if (this.itens) {
				this.totalItens = this.itens.length
			}
		}
	},

	components: {
		appPaginacao: PaginacaoComponent,
		appFiltroTabela: FiltroTabelaComponent
	}
}
</script>



// WEBPACK FOOTER //
// src/components/TabelaComponent.vue